import styled from 'styled-components';

export const NoCollapseArrayStringContainer = styled.div`
  ul {
    margin-bottom: 0;
  }
`;